import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import PopUp from '../../../../../Shared/Popup/PopUp';
import BtnSubmit from '../../../../../Shared/Buttons/BtnSubmit';
import BtnWhite from '../../../../../Shared/Buttons/BtnWhite';

function SortingCallsPopUp(props) {
  const [sorting, setSorting] = useState({});

  const getSortingData = (isReset) => {
    return {
      date: isReset ? '' : props.sortingData['date'],
      operator: isReset ? '' : props.sortingData['operator'],
      duration: isReset ? '' : props.sortingData['duration'],
      subscriberNumber: isReset ? '' : props.sortingData['subscriberNumber'],
      price: isReset ? '' : props.sortingData['price'],
    };
  };

  useEffect(() => {
    setSorting(getSortingData());
  }, [props.sortingData]);

  const getRadioBtnText = (key) => {
    let sortObject = {};
    switch (key) {
      case 'date':
        sortObject.title = 'תאריך';
        sortObject.descText = 'מחדש לישן';
        sortObject.ascText = 'מישן לחדש';
        break;
      case 'operator':
        sortObject.title = 'שם המפעיל';
        sortObject.descText = "ת'-א'";
        sortObject.ascText = "א'-ת'";
        break;
      case 'duration':
        sortObject.title = 'כמות שנצרכה';
        sortObject.descText = 'מגבוה לנמוך';
        sortObject.ascText = 'מנמוך לגבוה';
        break;
      case 'subscriberNumber':
        sortObject.title = 'מספר שחוייג';
        sortObject.descText = 'מספר עולה ליורד';
        sortObject.ascText = 'מספר יורד לעולה';
        break;
      case 'price':
        sortObject.title = 'סכום';
        sortObject.descText = 'מגבוה לנמוך';
        sortObject.ascText = 'מנמוך לגבוה';
        break;
    }
    return sortObject;
  };

  function onChangeSort(key, sortType) {
    setSorting((prevSorting) => {
      const newSorting = {};
      // Set all keys to have sort: ''
      for (const k in prevSorting) {
        if (prevSorting.hasOwnProperty(k)) {
          newSorting[k] = '';
        }
      }
      // Set the specific key to the provided sortType
      newSorting[key] = sortType;
      return newSorting;
    });
  }

  function onClickSaveSorting() {
    props.onClickSaveSorting(sorting);
  }

  function onClickResetSorting() {
    setSorting(getSortingData(true));
    props.onResetSort();
  }

  function closePopUp() {
    setSorting(getSortingData(false));
    props.onClose();
  }

  return (
    <PopUp className='sorting-calls-popup' showPopUp={props.showPopUp} onClose={closePopUp}>
      <div className='content'>
        <h2>מיון לפי</h2>
        <div className='sort-wrapper'>
          {Object.entries(props.sortingData).map(([key, value]) => {
            const radioBtnText = getRadioBtnText(key);
            return (
              <div className='sort-item'>
                <h3>{radioBtnText.title}</h3>
                <label>
                  <input
                    type='radio'
                    name='call-details-sort'
                    value={`${key}-asc`}
                    checked={sorting[key] == 'asc'}
                    onChange={() => {
                      onChangeSort(key, 'asc');
                    }}
                  />
                  {radioBtnText.ascText}
                </label>
                <label>
                  <input
                    type='radio'
                    name='call-details-sort'
                    value={`${key}-desc`}
                    checked={sorting[key] == 'desc'}
                    onChange={() => {
                      onChangeSort(key, 'desc');
                    }}
                  />
                  {radioBtnText.descText}
                </label>
              </div>
            );
          })}
        </div>
        <div className='btn-wrapper'>
          <BtnWhite text='נקה בחירה' onclick={onClickResetSorting} />
          <BtnSubmit text='בחר' onclick={onClickSaveSorting} />
        </div>
      </div>
    </PopUp>
  );
}

const mapStateToProps = (state) => {
  return {};
};
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SortingCallsPopUp);
